let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1GQ88")).then(() => parcelRequire('cRAIo'));